import { get } from '../../base-portal-api';

import { MerchantProductStatisticsResponse } from './types-product-statistics';

export function getPosMerchantProductStatistics(merchantId: string): Promise<MerchantProductStatisticsResponse> {
  return get(`v1/pos/merchants/${merchantId}/product-statistics`).json();
}
